import BaseService from './BaseService'

export default class CommonService extends BaseService {
  constructor () {
    super({
      title: '',
      menu: false,
      info: false,
      tool: false,
      share: false
    })
  }

  get share () {
    return this.data.share
  }

  set share (value) {
    this.data.share = value
  }

  get tool () {
    return this.data.tool
  }

  set tool (value) {
    this.data.tool = value
  }

  get info () {
    return this.data.info
  }

  set info (value) {
    this.data.info = value
  }

  get title () {
    return this.data.title
  }

  set title (value) {
    this.data.title = value
  }

  get menu () {
    return this.data.menu
  }

  set menu (value) {
    this.data.menu = value
  }

  get noHead () {
    return window.isWechat
  }
}



// WEBPACK FOOTER //
// ./src/service/CommonService.js